import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SubjectIdPlatformState = {
    SubjectIdPlatformMapData: Record<string, string | null>; // classId-subjectId → platform
};

const initialState: SubjectIdPlatformState = {
    SubjectIdPlatformMapData: {},
};

const subjectIdPlatformSlice = createSlice({
    name: 'subjectIdPlatformSlice',
    initialState,
    reducers: {
        setsubjectIdPlatformMapData: (
            state,
            action: PayloadAction<Record<string, string | null>>
        ) => {
            state.SubjectIdPlatformMapData = action.payload;
        },
    },
});

export const { setsubjectIdPlatformMapData } = subjectIdPlatformSlice.actions;
export default subjectIdPlatformSlice.reducer;
